var map = {
	"./activities.jpg": 58639,
	"./application-users.jpg": 45615,
	"./saas-graph-filters.jpg": 17229,
	"./saas-graph.jpg": 58463,
	"./source-accordion-activities.jpg": 1146,
	"./source-accordion-overview.jpg": 51732,
	"./source-accordion-risks.jpg": 50793,
	"./source-accordion-third-party-applications.jpg": 69561,
	"./source-accordion-users.jpg": 45397,
	"./source-shadow-saas-accordion-business-justification.jpg": 70248,
	"./source-shadow-saas-accordion-overview.jpg": 23666,
	"./source-shadow-saas-accordion-risks.jpg": 44687,
	"./source-shadow-saas-accordion-users.jpg": 20175,
	"./third-party-applications.jpg": 52008,
	"./workflows.jpg": 688,
	"assets/jpg/blurred-images/activities.jpg": 58639,
	"assets/jpg/blurred-images/application-users.jpg": 45615,
	"assets/jpg/blurred-images/saas-graph-filters.jpg": 17229,
	"assets/jpg/blurred-images/saas-graph.jpg": 58463,
	"assets/jpg/blurred-images/source-accordion-activities.jpg": 1146,
	"assets/jpg/blurred-images/source-accordion-overview.jpg": 51732,
	"assets/jpg/blurred-images/source-accordion-risks.jpg": 50793,
	"assets/jpg/blurred-images/source-accordion-third-party-applications.jpg": 69561,
	"assets/jpg/blurred-images/source-accordion-users.jpg": 45397,
	"assets/jpg/blurred-images/source-shadow-saas-accordion-business-justification.jpg": 70248,
	"assets/jpg/blurred-images/source-shadow-saas-accordion-overview.jpg": 23666,
	"assets/jpg/blurred-images/source-shadow-saas-accordion-risks.jpg": 44687,
	"assets/jpg/blurred-images/source-shadow-saas-accordion-users.jpg": 20175,
	"assets/jpg/blurred-images/third-party-applications.jpg": 52008,
	"assets/jpg/blurred-images/workflows.jpg": 688
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72046;